import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  FlatList,
  View,
  Linking,
  Alert,
} from "react-native";
import Text from "@components/CustomText";
import { useDispatch, useSelector } from "react-redux";
import colors from "@constants/color";
import NoOrdersGraphic from "@assets/svg/NoOrdersGraphic";
import metrics from "@constants/metrics";
import t from "@constants/localization";
import Share from "react-native-share";

// Events
import analytics from "@services/analytics";
import { MY_ORDERS_EVENTS } from "@constants/analyticsEventsCT";
import testIds from "@constants/testIds";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import {
  cancelLeaderCustomSkuOrder,
  getLeaderCustomSkuOrders,
} from "@services/api";
import ReturnOrderCard from "./View/ReturnOrderCard";
import CustomModal from "./CustomModal";

import OrderCard from "./View/OrderCard";
import { actions as orderActions } from "../../reducers/orderReducer";

const PATH = "screens/OtherOrdersList/index";
const PATH2 = "WhatsAppAlert";

const keyExtractor = (item, index) => String(index);

function OrderList(props) {
  const {
    route: { params },
  } = props;

  const dispatch = useDispatch();
  const { allOrders, totalCount } = useSelector((s) => s.orders);
  const [loading, setLoading] = useState(true);
  const {
    allReturnOrders,
    totalCount: totalReturnOrderCount,
    modalValues,
  } = useSelector((s) => s.returnOrders);
  const navigation = useNavigation();

  const [isOrders, setIsOrders] = useState(true);
  const [endReached, setEndReached] = useState(false);
  const [ordersList, setOrdersList] = useState([]);

  useEffect(() => {
    getLeaderOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLeaderOrders = (offset) => {
    getLeaderCustomSkuOrders({
      limit: 10,
      offset: offset ? 0 : ordersList.length,
    }).then(({ data }) => {
      setOrdersList(data.skus);
      setLoading(false);
    });
  };

  const onCancelOrder = (juspay_order_id) => {
    Alert.alert(
      t(`${PATH}/cancelOrder`),
      t(`${PATH}/cancelOrderDesc`),
      [
        {
          text: t(`${PATH}/cancelOrderCtaNo`),
          onClose: () => {},
        },
        {
          text: t(`${PATH}/cancelOrderCtaYes`),
          onPress: () => {
            cancelLeaderCustomSkuOrder({ juspay_order_id }).then(() => {
              getLeaderOrders(true);
            });
          },
        },
      ],
      { cancelable: true },
    );
  };

  const _renderItem = ({ item, index }) => {
    if (isOrders) {
      return (
        <OrderCard
          item={item}
          index={index}
          navigateToDetails={navigateToDetails}
          navigateToRating={navigateToRating}
          onWaShare={onWaShare}
          onCancelOrder={onCancelOrder}
        />
      );
    } else {
      return (
        <ReturnOrderCard item={item} navigateToDetails={navigateToDetails} />
      );
    }
  };

  const onWaShare = async (share_message, user_phone, order_id) => {
    const { isInstalled: haveWhatsApp } =
      await Share.isPackageInstalled("com.whatsapp");
    if (!haveWhatsApp) {
      Alert.alert(
        t(`${PATH2}/title`),
        t(`${PATH2}/message`),
        [
          {
            text: t(`${PATH2}/onCloseText`),
            onClose: () => {},
          },
        ],
        { cancelable: true },
      );
    }
    user_phone &&
      Linking.openURL(
        `whatsapp://send?text=${share_message}&phone=+91${user_phone}`,
      );
    analytics.trackEvent(MY_ORDERS_EVENTS.ORDER_SHARE, {
      order_id,
    });
  };

  const navigateToDetails = (order_id, source) => {
    dispatch(
      orderActions.setSelectedOrder({
        orderId: parseInt(order_id, 10),
        source,
      }),
    );
    navigation.navigate("OrderDetails");

    analytics.trackEvent(MY_ORDERS_EVENTS.ORDER_CARD_CLICK, {
      screen_name: params?.screen_name,
      order_id,
    });
  };

  const navigateToRating = (navParams) => {
    navigation.navigate("RateOrder", navParams);
  };

  const loadMore = () => {
    if (isOrders && !endReached && !loading) {
      getLeaderCustomSkuOrders({
        limit: 10,
        offset: ordersList.length,
      }).then(({ data }) => {
        setOrdersList([...ordersList, ...data.skus]);
        setLoading(false);
      });
    }
  };

  const ListFooterComponent = () => {
    return (isOrders &&
      allOrders.length < totalCount &&
      !loading &&
      !params.fromShop) ||
      (!isOrders &&
        allReturnOrders &&
        allReturnOrders.length < totalReturnOrderCount) ? (
      <View style={{ paddingVertical: 10, backgroundColor: "white" }}>
        <ActivityIndicator size="large" color={colors.primary} />
      </View>
    ) : null;
  };

  return (
    <View style={{ flex: 1 }} testID={testIds.OrdersList}>
      <CustomModal
        visible={!!modalValues}
        heading={modalValues?.heading}
        message={modalValues?.message}
        buttons={modalValues?.buttons}
        onPress={modalValues?.onPress}
      />
      <HeaderWithBackAndTitle
        headertitle="अन्य ऑर्डर्स"
        headerColor="#fff"
        hideShadow={false}
        navigation={props.navigation}
        route={props.route}
      />
      {loading ? (
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : (
        <FlatList
          testID={testIds.order_list}
          data={ordersList}
          renderItem={_renderItem}
          keyExtractor={keyExtractor}
          contentContainerStyle={{ marginTop: 5, paddingBottom: 60 }}
          onEndReached={loadMore}
          onEndReachedThreshold={0.5}
          ListEmptyComponent={
            !loading && ordersList?.length === 0 ? (
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  paddingVertical: metrics.screenHeight * 0.125,
                }}
              >
                <NoOrdersGraphic />
                <Text
                  fontType="content1"
                  style={{
                    color: colors.lightBlack,
                    textAlign: "center",
                    paddingTop: 20,
                  }}
                >
                  {t(`${PATH}/noOrders`)}
                </Text>
              </View>
            ) : null
          }
          ListFooterComponent={ListFooterComponent}
        />
      )}
    </View>
  );
}

export default OrderList;
